// extracted by mini-css-extract-plugin
export default {"text-overflow":"_W9NJg","flex-between":"__NA6V","flex-align":"_31Fdk","check":"_3rvC7","close":"_SHeko"};